import React, { useContext } from 'react';
import { Link } from 'react-router-dom';

import { IdentityContext } from '../../context';
import { Button } from '../basic-inputs';

export function PortfolioOption({ option, icon, bgImg = '' }) {
  const person = useContext(IdentityContext);
  const { id: personId } = person;

  const style = bgImg ? {
    backgroundImage: `url(${bgImg})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  } : null;

  return (
    <div className="portfolio-option">
      <Link
        to={`/people/${personId ?? 'self'}/life-documents/${option.toLowerCase().replace(/ /g, '-')}`}
      >
        <Button fullWidth style={style}>
          {style ?
            null : (
              <>
                <span className="material-symbols-outlined">{icon}</span>
                <span>{option}</span>
              </>
            )
          }
        </Button>
      </Link>
    </div>
  );
}
